var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58317 6.49998C6.26843 7.61015 5.32655 9.0975 4.88505 10.7607C4.44355 12.4238 4.52375 14.1825 5.1148 15.7986C5.70584 17.4146 6.77919 18.8101 8.18952 19.796C9.59986 20.7819 11.2791 21.3106 12.9998 21.3106C14.7206 21.3106 16.3998 20.7819 17.8102 19.796C19.2205 18.8101 20.2938 17.4146 20.8849 15.7986C21.4759 14.1825 21.5561 12.4238 21.1146 10.7607C20.6731 9.0975 19.7313 7.61015 18.4165 6.49998M12.9998 4.33331V13",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.dd761cce9252a778a7832fa2eed3e56b.svg";
export { ForwardRef as ReactComponent };